import Shuffle from 'shufflejs';

const setCardClass = (items) => {

    if(items.length === 0 || !items){
        return false;
    }

    let c = 1;
    items.forEach((item) => {

        item.element.classList.remove('is-2');
        item.element.classList.remove('is-3');

        if(c === 2 || c === 3){
            item.element.classList.add(`is-${c}`);
        }


        c = c === 4 ? 1 : c + 1;
    });
}

const init = () => {

    const filtersSection = document.querySelector('.items-to-filter');
    
    const resizeItems = () => {
        let Wwidth = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

        if(Wwidth <= 768){return false;}
        
        let h = 0;
        let elems = document.querySelectorAll('.filter-item');
        elems.forEach(el => {
            el.style.height = 'auto';
            h = el.offsetHeight > h ? el.offsetHeight : h;
        });

        elems.forEach(el => {
            el.style.height = h + 'px';
        });

    }

    if(filtersSection){

        const shuffleInstance = new Shuffle(filtersSection, {
            itemSelector: '.filter-item',
            buffer: 1,
            sizer: document.querySelector('.js-shuffle-sizer'),
            filterMode: Shuffle.FilterMode.ALL
        });


        const updateFilterSelection = () => {

            let filterSelection = [];
            
            Array.from(document.querySelectorAll('.filter a[data-group]')).forEach(filter => {

                if(filter.classList.contains('current')){
                    let val = parseInt(filter.dataset.group);
                    if(val){
                        filterSelection.push(val);
                    }
                }
            });

            shuffleInstance.filter(filterSelection);
        };

        document.querySelectorAll('.filter').forEach((filterGroup) => {

            let filterGroupLabel = filterGroup.querySelectorAll('button .output');

            filterGroup.querySelectorAll('a').forEach((filter) => {

                filter.addEventListener('click', () => {
                    let filterVal = parseInt(filter.dataset.group) ? parseInt(filter.dataset.group) : '';
                    let filterLabel = filter.innerHTML;

                    filterGroupLabel.forEach((label) => { label.innerHTML = filterLabel; });

                    if(!filterVal){
                        let sortVal = filter.dataset.sort;

                        function sortByDate(element) {
                            return element.dataset.created;
                        }

                        function sortByTitle(element) {
                            return element.dataset.title.toLowerCase();
                        }

                        let options;
                        if (sortVal === 'new') {
                            options = {
                                reverse: true,
                                by: sortByDate,
                            };
                        } else if (sortVal === 'title') {
                            options = {
                                by: sortByTitle,
                            };
                        } else {
                            options = {};
                        }

                        shuffleInstance.sort(options);
                        setCardClass(shuffleInstance.sortedItems);
                    }
                

                    filterGroup.querySelectorAll('a').forEach((item) => item.classList.remove('current'));
                    filter.classList.add('current');

                    updateFilterSelection();
                });
            });
        });

        shuffleInstance.on(Shuffle.EventType.LAYOUT, (data) => {
                resizeItems();
            setCardClass(data.shuffle.sortedItems);
        });

        setCardClass(shuffleInstance.sortedItems);

        resizeItems();
    }
}

export default { init };